import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

type DeleteTeamModalProps = {
    isOpen: boolean;
    teamName: string;
    isDeleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const DELETE_TEAM_MODAL_STYLES = {
    content: {
        width: `420px`,
        padding: "0",
    },
};

export const DeleteTeamModal = ({ isOpen, teamName, isDeleting, onCancel, onConfirm }: DeleteTeamModalProps) => {
    const { translate } = useTranslate();

    const handleRequestClose = () => {
        if (isDeleting) {
            return;
        }
        onCancel();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleRequestClose}
            customStyles={DELETE_TEAM_MODAL_STYLES}
            data-automation="delete-team-modal"
        >
            <Modal.Header>
                <Modal.Title data-automation="delete-team-modal-title">
                    {translate("si.management.teams.delete.title")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Content>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon["400"]}
                    data-automation="delete-team-modal-confirmation"
                >
                    {translate("si.management.teams.delete.confirmation", { name: teamName })}
                </Text>
            </Modal.Content>
            <Modal.Footer>
                <Button
                    type="flatDark"
                    onClick={onCancel}
                    isDisabled={isDeleting}
                    dataAutomation="delete-team-modal-cancel"
                >
                    {translate("si.common.button.cancel")}
                </Button>
                <Button
                    type="warning"
                    onClick={onConfirm}
                    isDisabled={isDeleting}
                    isLoading={isDeleting}
                    dataAutomation="delete-team-modal-confirm"
                >
                    {translate("si.common.button.delete")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
